import { render } from "./AuthenticatedMedia.vue?vue&type=template&id=2c61a292"
import script from "./AuthenticatedMedia.vue?vue&type=script&lang=js"
export * from "./AuthenticatedMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__